import React from "react";

const ModalBody = ({ children }) => {
  return <div className='p-3 text-white max-h-[calc(100vh-250px)] overflow-auto'>{children}</div>;
};

export default ModalBody;
